<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="col-12 text-center">
          <h1>Request a Price</h1>
          <p class="col-12" role=tagline>Fields marked with a <strong class="required-indicator">*</strong> are required. If you do not have the <em>Brand</em>, <em>Product Title</em> or <em>Product Code</em> please type <strong>N/A</strong></p>
        </div>
        <div class="submissionText" ref="submitText">
          <p>Thanks for asking for a price from us.  Sometimes it takes a bit of time for our brand suppliers to get back to us with a price.  But we will be back to you as soon as we can.</p>
        </div>
        <form class="row" ref="submitForm" v-on:submit.prevent="submitPriceRequest">

          <InputField 
            v-validate="'required|email'"
            v-model="email"
            label="Email"
            :required="true"
            type="email"
            class="col-12"
            data-vv-validate-on="input"
            :error="errors.first('Email')"
          />

          <InputField 
            v-validate="'required'"
            v-model="productTitle"
            label="Product Title"
            :required="true"
            type="text"
            class="col-12"
            data-vv-validate-on="input"
            :error="errors.first('Product Title')"
          />

          <InputField 
            v-validate="'required'"
            v-model="productCode"
            label="Product Code"
            :required="true"
            type="text"
            class="col-12 col-md-6"
            data-vv-validate-on="input"
            :error="errors.first('Product Code')"
          />

          <InputField 
            v-validate="'required'"
            v-model="brand"
            label="Brand"
            :required="true"
            type="text"
            class="col-12 col-md-6"
            data-vv-validate-on="input"
            :error="errors.first('Brand')"
          />


          <InputField
            v-model="size"
            label="Size"
            type="text"
            class="col-12 col-md-6"
          />

          <InputField
            v-model="colour"
            label="Colour"
            type="text"
            class="col-12 col-md-6"
          />

          <TextareaField
            v-model="description"
            label="Description"
            class="col-12"
          />          

          <ButtonWithLoading
            v-if="validDetails"
            class="mx-auto my-3 mr-md-3"
            type="submit"
            :state="submitState"
            text="Submit"
            loadingText="Submitting"
            successText="Submitted"
            failureText="Problem Submitting"
          ></ButtonWithLoading>

          <div v-else class="alert alert-danger col-12">
            You have not yet set your delivery details. You can add these in your <router-link :to="{ name: 'account' }">account</router-link>.
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonWithLoading from "@/components/buttonWithLoading";
import InputField from "@/components/forms/InputField";
import TextareaField from "@/components/forms/TextareaField";
import { postPriceRequest, fetchUserDetails } from "@/network/userRequests";

export default {
  name: "PriceRequest",
  components: {
    ButtonWithLoading,
    InputField,
    TextareaField
  },
  data() {
    return {
      buttonState: null,
      description: "",
      colour: "",
      email:"",
      productCode: "",
      productTitle: "",
      brand: "",
      size: "",
      submitState: null,
      //url: "",
      //image:"",
      //mime:"",
      //imageName:"",
      loading:false,
      user: null
    };
  },
  created() {
    const vars = this.$route.query;

    if ("brand" in vars) {
      this.brand = vars.brand;
    }

    if("productCode" in vars){
      this.productCode = vars.productCode
    }
    this.getData();
  },
  methods:{
    getData(){
      this.loading = true;
      fetchUserDetails(userDetails => {
        this.user = userDetails;
        this.loading = false;
      });
    },
    submitPriceRequest(){
      this.$validator.validateAll().then(valid => {
        if (!valid) return;
        this.submitState = "loading";
        let {colour, productCode, brand, description, size, email, productTitle} = this; //, url, image,mime
        postPriceRequest({colour, productCode, brand, description, size, email, productTitle},//, url,image,mime},
          ()=>{ //success
            this.$refs.submitText.style.display = "block";
            this.$refs.submitForm.style.display = "none";

            this.submitState = "success";
            setTimeout(() => {
              this.submitState = null;
            }, 5000);
          },
          error =>{
            this.submitState = "error";
            setTimeout(() => {
              this.submitState = null;
            }, 2000);
            console.log(error);
        })
      })
    },
    // toBase64(file){
    //   return new Promise((resolve, reject) => {
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onload = () => resolve(reader.result);
    //     reader.onerror = error => reject(error);
    //   });
    // },
    // onFileChange(e) {
    //   var files = e.target.files || e.dataTransfer.files;
    //   if (!files.length){
    //     this.imageName=''
    //     this.image=''
    //     this.mime=''
    //     return;
    //   }
    //   this.imageName = files[0].name
    //   this.mime=files[0].type
    //   this.toBase64(files[0]).then((data) => {
    //     this.image=data
    //   })
    // },
  },
  computed:{
    validDetails(){
      if(this.user==null){
        return false;
      }
      let details = this.user.member_details
      if(details.delivery_city && details.delivery_postcode && details.delivery_street_address){
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
  .submissionText {
    display: none;
    font-weight: 500;
    font-size: 1.2rem;
    background-color: #eee;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 10px;
    margin-bottom: 20px;
    p { 
      margin-bottom: 0;
    }
  }

//   #image{
//     width: 0.1px;
//     height: 0.1px;
//     opacity: 0;
//     overflow: hidden;
//     position: absolute;
//     margin:0;
//     z-index: -1;
//   }
//   #imageLabel{
//     font-weight: 700;
//     color: white;
//     padding:10px;
//     height: auto;
//     background-color: #AF272F;
//     display: inline-block;
//     cursor: pointer;
//     margin: 0;
//   }
//   #image:focus #imageLabel, #imageLabel:hover{
//     background-color: #902027;
//   }

//   #imageContainer{
//     border:none;
//     height: auto;
//     padding-left:0;
//     padding-right:0;
//   }

</style>
